export default __webpack_public_path__ + "static/media/iso-14001.9067157a.jpg";